import { type StrapiClient, strapi } from "@strapi/client";

import { getSessionStorageFor } from "./http/cookies";

const baseURL = import.meta.env.VITE_APP_API_URL;

export const getStrapiClient = (): StrapiClient =>
	strapi({
		baseURL,
		auth: getSessionStorageFor("token") || undefined,
	});
